module.exports = __webpack_public_path__ + "static/img/bg3.4e1fbce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/bg3.png
// module id = oM7E
// module chunks = 0